import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

export async function extractTextFromPdf(file) {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onload = async () => {
      const typedarray = new Uint8Array(fileReader.result);

      try {
        const pdf = await pdfjsLib.getDocument({ data: typedarray }).promise;
        let fullText = "";

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();

          // JUNTA OS ITENS PRESERVANDO QUEBRAS DE LINHA ENTRE BLOCOS
          let lastY = null;
          let pageText = "";
          textContent.items.forEach((item) => {
            if (lastY !== null && Math.abs(item.transform[5] - lastY) > 5) {
              pageText += "\n";
            }
            pageText += item.str + " ";
            lastY = item.transform[5];
          });
          fullText += pageText + "\n";
        }

        resolve(fullText);
      } catch (error) {
        console.error("Erro ao processar PDF:", error);
        reject(
          "Erro ao processar PDF. Verifique se é um arquivo PDF válido e legível."
        );
      }
    };

    fileReader.onerror = (error) => {
      reject("Erro ao ler o arquivo: " + error.target.error.message);
    };

    fileReader.readAsArrayBuffer(file);
  });
}
